import { get } from 'lodash';

/**
 * Gets an abgroup for ad targeting
 *
 * @param {object} config - context.config
 * @returns {string} some abgroup
 */
export function getAbGroup(config) {
  const queryParam = get(config, 'initialQueryParams.abgroup');
  if (queryParam) {
    return queryParam;
  }
  const abgroup = get(window, 'digitalData.user[0].segment.abGroup') || '0';
  return abgroup;
}
